import React, { Component } from 'react';
import { connect } from 'react-redux';
import mori from 'mori';
import { UPDATE_SELECTED } from '../../config/types';
import actionTrigger from '../../actions';

class DistributionSelector extends Component {
  static renderOption(option) {
    return (
      <option
        value={option.slug}
        key={option.slug}
      >{option.label}</option>
    );
  }

  constructor() {
    super();
    this.state = {};

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(evt) {
    evt.preventDefault();
    this.props.dispatch(actionTrigger(
      UPDATE_SELECTED,
      { selectedDistributions: evt.target.value }
    ));
  }

  render() {
    if (1 >= this.props.distributions.length) {
      return null;
    }
    return (
      <form onSubmit={() => {}}>
        <select
          value={this.props.selectedDistributions}
          onChange={this.handleChange}
        >
          {this.props.distributions.map((distribution) =>
            this.constructor.renderOption(distribution))}
        </select>
      </form>
    );
  }
}

DistributionSelector.propTypes = {
  dispatch: React.PropTypes.func,
  distributions: React.PropTypes.array,
  selectedDistributions: React.PropTypes.string,
};

export default connect((state) => ({
  distributions: mori.toJs(state.data.immutableDistributions),
  selectedDistributions: state.data.selectedDistributions,
}))(DistributionSelector);



// WEBPACK FOOTER //
// ./app/components/distributionSelector/index.js